import { GENERIC_CONCESSION_VALIDATION_ERROR } from './concessionValidationConstants'

export const getDefaultConcessionVendor = () => ({
  name: '',
  image: { url: '', alt: '' },
  description: '',
  badge: null,
  filters: {
    cuisine: [],
    dietary_preferences: [],
    location: []
  },
  section_label: ''
})

const normalizeVendorImage = image => {
  if (!image || typeof image !== 'object') {
    return { url: '', alt: '' }
  }

  return {
    url: String(image.url || image.src || '').trim(),
    alt: String(image.alt ?? '').trim()
  }
}

const normalizeVendorFilters = filters => ({
  cuisine: Array.isArray(filters?.cuisine) ? filters.cuisine : [],
  dietary_preferences: Array.isArray(filters?.dietary_preferences)
    ? filters.dietary_preferences
    : (Array.isArray(filters?.dietary) ? filters.dietary : []),
  location: Array.isArray(filters?.location) ? filters.location : []
})

export const normalizeConcessionVendor = (vendor = {}) => ({
  name: String(vendor.name ?? '').trim(),
  image: normalizeVendorImage(vendor.image),
  description: String(vendor.description ?? '').trim(),
  badge: vendor.badge ?? null,
  filters: normalizeVendorFilters(vendor.filters),
  section_label: String(vendor.section_label ?? '').trim()
})

export const normalizeConcessionVendors = vendors =>
  (Array.isArray(vendors) ? vendors : []).map(normalizeConcessionVendor)

export const getEmptyConcessionVendorFieldErrors = () => ({
  name: '',
  image: '',
  description: '',
  location: '',
  cuisine: '',
  dietary_preferences: ''
})

export const getConcessionVendorFieldErrors = (vendor = {}) => {
  const normalized = normalizeConcessionVendor(vendor)

  return {
    name: !normalized.name ? 'Header is required' : '',
    image: !normalized.image.url ? 'Image is required' : '',
    description: !normalized.description ? 'Description is required' : '',
    location: !normalized.filters.location.length ? 'Location is required' : '',
    cuisine: !normalized.filters.cuisine.length ? 'Cuisine is required' : '',
    dietary_preferences: !normalized.filters.dietary_preferences.length
      ? 'Dietary preference is required'
      : ''
  }
}

export const getConcessionVendorGridSectionFieldErrors = (section = {}) => {
  if (section.enabled === false) {
    return {
      title: '',
      vendors: []
    }
  }

  const vendors = Array.isArray(section.vendors) ? section.vendors : []

  return {
    title: !String(section.title ?? '').trim() ? 'Section header is required' : '',
    vendors: vendors.map(vendor => getConcessionVendorFieldErrors(vendor))
  }
}

export const hasConcessionVendorGridSectionFieldErrors = (fieldErrors = {}) => {
  if (fieldErrors.title) {
    return true
  }

  return (fieldErrors.vendors || []).some(itemErrors =>
    Object.values(itemErrors || {}).some(Boolean)
  )
}

export const validateConcessionVendorGridSection = (section = {}) => {
  const fieldErrors = getConcessionVendorGridSectionFieldErrors(section)

  if (hasConcessionVendorGridSectionFieldErrors(fieldErrors)) {
    return {
      isValid: false,
      message: GENERIC_CONCESSION_VALIDATION_ERROR,
      fieldErrors
    }
  }

  return { isValid: true, fieldErrors }
}
